
/**
 * Utility functions for formatting data in premium bot components
 */

/**
 * Format large numbers with K/M suffixes
 */
export const formatNumber = (num: number) => {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  return num.toString();
};

/**
 * Format exchange platforms for display
 */
export const formatExchanges = (exchanges: string[] | null) => {
  if (!exchanges || exchanges.length === 0) return "";
  return exchanges.join(", ");
};

/**
 * Format percentage values with + or - signs
 */
export const formatPercentage = (value: string | undefined | null, isMaxDrawdown: boolean = false) => {
  if (value === undefined || value === null || value === "") {
    return "N/A";
  }
  
  const numericValue = parseFloat(value);
  if (isNaN(numericValue)) {
    return value;
  }
  
  // For Max Drawdown, always use "-" sign
  if (isMaxDrawdown) {
    return `-${Math.abs(numericValue)}%`;
  }
  
  // For Potential Profit, use "+" for positive values
  return `${numericValue > 0 ? '+' : ''}${numericValue}%`;
};

/**
 * Check if a profit value is positive
 */
export const isProfitPositive = (value: string | undefined | null): boolean => {
  if (!value) return false;
  const numericValue = parseFloat(value);
  return !isNaN(numericValue) && numericValue > 0;
};
